import { useQueryClient, useMutation } from '@tanstack/react-query'
import { useApiClient } from 'hooks/useApiClient'
import { type CelebrationRequest } from 'types/fileUpload'

interface UsePutCelebrationProps {
  id: number
  onSuccess?: (data: boolean, variables: CelebrationRequest) => void
  onError?: (error: Error, variables: CelebrationRequest) => void
}

export const usePutCelebrations = ({
  id,
  onSuccess,
  onError,
}: UsePutCelebrationProps) => {
  const putAPIClient = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (files: CelebrationRequest) => {
      const body = new FormData()
      body.set('AnimationFileUpload', files.AnimationFile)
      body.set('Type', files.Type)
      body.set('FileName', files.FileName)
      body.set('Description', files.Description)

      const { data, error } = await putAPIClient.put('/celebrations/{id}', {
        params: { path: { id } },
        body: {
          Type: files.Type,
          Description: files.Description,
          FileName: files.FileName,
        },
        bodySerializer: () => body,
      })
      return { data, error }
    },
    onSuccess: async ({ data, error }, variables: CelebrationRequest) => {
      await queryClient.invalidateQueries({
        queryKey: ['/celebrations'],
      })
      if (error !== undefined) {
        onError?.(error as Error, variables)
      } else {
        onSuccess?.(data as any, variables)
      }
    },
    onError,
  })
}
